const state = {
  currentModal: '',
  isMoving: false
}

export const getters = {
  currentModal: state => state.currentModal,
  isMoving: state => state.isMoving
}

export const actions = {
  setCurrentModal ({ commit }, modalName) {
    commit('SET_CURRENT_MODAL', modalName)
  },
  updateIsMoving ({ commit }, bool) {
    commit('SET_ISMOVING', bool)
  }
}

export const mutations = {
  SET_CURRENT_MODAL (state, modalName) {
    state.currentModal = modalName
  },
  SET_ISMOVING (state, bool) {
    state.isMoving = bool
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
